import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ConnectionStatusOptions, IotDeviceLog} from '@models/adminstration/gateway/iot-device-log';

@Component({
    selector: 'scitis-admin-gateway-log-iot-actions',
    templateUrl: './gateway-log-iot-actions.component.html',
    styleUrls: ['./gateway-log-iot-actions.component.scss'],
    standalone: false
})
export class GatewayLogIotActionsComponent {

  @Input()
  public logData: IotDeviceLog[] = [];

  @Input()
  public disableRefreshButton: boolean = false;

  @Input()
  public disableCSVExportButton: boolean = false;

  @Output()
  public refreshTrigger: EventEmitter<any> = new EventEmitter();

  public showConnectStatuses: boolean = true;
  public showDisconnectStatuses: boolean = true;
  public ConnectionStatusEnum = ConnectionStatusOptions;

  constructor() { }

  public onRefresh(): void {
    this.refreshTrigger.emit();
    this.showConnectStatuses = true;
    this.showDisconnectStatuses = true;
  }

  public onExportCSV(): void {}

  public onFiltersChange($event: any, status) {
    if (status === ConnectionStatusOptions.CONNECTED) {
      this.showConnectStatuses = $event.target.checked;
    } else {
      this.showDisconnectStatuses = $event.target.checked;
    }
  }

  public onFilterByStatusType():void {
    const visibleConnectionStatuses: ConnectionStatusOptions[] = [];

    if (this.showConnectStatuses) {
      visibleConnectionStatuses.push(ConnectionStatusOptions.CONNECTED);
    }
    if (this.showDisconnectStatuses) {
      visibleConnectionStatuses.push(ConnectionStatusOptions.DISCONNECTED);
    }
    this.refreshTrigger.emit(visibleConnectionStatuses);
  }
}
